import { RouteRecordRaw } from 'vue-router';

export const TECH_EXPLORATION_DETAILS_PATH = '/tech-exploration/:uuid';

export const techExplorationRouteConfigs: RouteRecordRaw = {
  name: 'techExploration',
  path: '/tech-exploration',
  component: () => import('@/components/tech-exploration/layouts/main.vue'),
  children: [
    {
      path: '/tech-exploration/top',
      component: () =>
        import('@/components/tech-exploration/tech-exploration.vue'),
      name: 'techExplorationTop',
      meta: { title: '技術探索トップ', type: 'techExploration' },
    },
    {
      path: '/tech-exploration/settings',
      meta: { title: '技術探索設定', type: 'techExploration' },
      children: [
        {
          path: '',
          redirect: {
            name: 'techExplorationSettingsNotification',
          },
        },
        {
          path: 'notification',
          component: () =>
            import(
              '@/components/tech-exploration/settings/notification-settings.vue'
            ),
          name: 'techExplorationSettingsNotification',
          meta: { title: '通知設定', type: 'techExploration' },
        },
      ],
    },
    {
      path: TECH_EXPLORATION_DETAILS_PATH,
      name: 'techExplorationDetails',
      redirect: { name: 'techExplorationDetailsView' },
      meta: { type: 'techExploration' },
      children: [
        {
          path: '',
          component: () =>
            import(
              '@/components/tech-exploration/details/tech-exploration-details.vue'
            ),
          name: 'techExplorationDetailsView',
          meta: { title: '技術探索解決策', type: 'techExploration' },
        },
        {
          path: 'comparison',
          component: () =>
            import(
              '@/components/tech-exploration/details/tech-exploration-comparison.vue'
            ),
          name: 'techExplorationComparison',
          meta: { title: '解決策比較', type: 'techExploration' },
        },
        {
          path: 'definition',
          component: () =>
            import(
              '@/components/tech-exploration/details/tech-exploration-definition.vue'
            ),
          name: 'techExplorationDefinition',
          meta: { title: '課題の定義', type: 'techExploration' },
        },
      ],
    },
  ],
};
